import { ENV } from 'public/config'
import { TITLE } from '../conf'
import 'public/utils/open'
import '../menu'
import './token'
// import './check-version'
import './online-status'
// 模块时长上报
import './time-on-page'
// 资源上报
import './resource-log'
// qt 上报配置
import './quick-track-config'
// 数据字典本地缓存
import './lookup-cache'
// 系统自动返回
import './system-comeback'
// 热力图
import './hot-map'
// 刷新页签保留功能
import './keep-tabs'
// qt 采集鼠标行为
import './report-mousedown'
// 输入框历史
import './input-autocomplete/init'
import './login'
import './font-family'
// 表格配置插件
import './table-config-plugin'

if (ENV) {
  if (ENV !== 'prd') {
    document.title = `${ENV.toUpperCase()}-${TITLE}`
  }
  if (ENV !== 'dev') {
    window.addEventListener('unhandledrejection', e => e.preventDefault())
  }
}

// Windows
if (navigator.platform.includes('Win')) {
  document.body.className += ' ky-erp-win'
}

// 检测 localStorage 是否超出容量
try {
  localStorage.setItem('checklocalstorage', 1)
  localStorage.removeItem('checklocalstorage')
} catch (e) {
  localStorage.clear()
}

// 文件下载离开时不弹出页面卸载提示框
window.onbeforeunload = function (e) {
  if (window.__intercept__ === 0) {
    return null
  }
  return false
}

// 2023-01-28 检测Event.path是否存在。不存在则使用兼容方法
try {
  if (Event) {
    const isExitPath = 'path' in Event.prototype
    const isExitPolyfillPath = 'composedPath' in Event.prototype
    if (!isExitPath && isExitPolyfillPath) {
      Object.defineProperty(Event.prototype, 'path', {
        get() {
          return this.composedPath()
        },
      })
    }
  }
} catch (error) {
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/index.js